// src/components/UserProfile.js
import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';

const UserProfile = () => {
  const { user, isAuthenticated, loginWithRedirect, logout, getAccessTokenSilently } = useAuth0();
  const [userScopes, setUserScopes] = useState('');

  useEffect(() => {
    const fetchScopes = async () => {
      if (isAuthenticated) {
        try {
          // Request an access token with specific scopes
          const token = await getAccessTokenSilently({
            audience: 'https://your-api-endpoint', // Your API identifier
            scope: 'openid profile email create:tenants' // Request the required scopes
          });

          // Decode the access token to check its content
          const tokenParts = token.split('.');
          const tokenPayload = JSON.parse(atob(tokenParts[1]));
          setUserScopes(tokenPayload.scope || 'No scopes found');
        } catch (error) {
          console.error('Error fetching token or scopes:', error);
        }
      }
    };

    fetchScopes();
  }, [isAuthenticated, getAccessTokenSilently]);

  if (!isAuthenticated) {
    return (
      <div>
        <button onClick={() => loginWithRedirect({ scope: 'openid profile email create:tenants' })}>
          Log In
        </button>
      </div>
    );
  }

  return (
    <div>
      <h2>Welcome, {user.name}!</h2>
      <img size='32px' src={user.picture} alt={user.name} />
      <p>Email: {user.email}</p>
      <p><strong>Scopes:</strong> {userScopes}</p>
      <p>
      <Link to="/" className="nav-link">Tenants</Link>
      <Link to="/add-tenant" className="nav-link">Add Tenants</Link>
      </p>
      <button onClick={() => logout({ returnTo: 'https://admin.sevis.click' })}>
        Log Out
      </button>
    </div>
  );
};

export default UserProfile;
